import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { LocalizationService } from '../services/localization/localization.service';
import { TestResultService } from '../services/test-result/test-result.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultGuard implements CanActivate {
  constructor(
    private localizationService: LocalizationService,
    private testResultService: TestResultService
  ) {}

  canActivate(): Observable<boolean> {
    const testResult$ = this.testResultService.getTestResult();

    return testResult$.pipe(
      map(result => {
        if (result) {
          return true;
        } else {
          this.localizationService.navigate(['test']);
          return false;
        }
      })
    );
  }
}
